import {Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar} from '@mui/material';
import {useTranslation} from 'react-i18next';
import ListIcon from '@mui/icons-material/List';
import {Link} from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import RadioIcon from '@mui/icons-material/Radio';
interface IProps {
	matches: boolean,
	open: boolean,
	handleDrawerToggle: () => void;
	drawerWidth: number
}

export default function Sidebar({matches, open, handleDrawerToggle, drawerWidth}: IProps) {
	const {t} = useTranslation();
	
	
	return (
		<Drawer
			variant={matches ? 'permanent' : 'temporary'}
			open={open}
			onClose={handleDrawerToggle}
			ModalProps={{
				keepMounted: true
			}}
			sx={{
				flexShrink: 0,
				width: drawerWidth,
				'& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth, transition: 'all 0.2s'}
			}}
		>
			{matches && <Toolbar/>}
			<List className="overflow-hidden">
				<ListItem disablePadding>
					<ListItemButton component={Link} to="/">
						<ListItemIcon>
							<HomeIcon/>
						</ListItemIcon>
						<ListItemText className="whitespace-nowrap" primary={t('home')}/>
					</ListItemButton>
				</ListItem>
				<Divider/>
				<ListItem disablePadding>
					<ListItemButton component={Link} to="/channel">
						<ListItemIcon>
							<ListIcon/>
						</ListItemIcon>
						<ListItemText className="whitespace-nowrap" primary={t('channels')}/>
					</ListItemButton>
				</ListItem>
				<Divider/>
				<ListItem disablePadding>
					<ListItemButton component={Link} to="/services">
						<ListItemIcon>
							<BlurOnIcon/>
						</ListItemIcon>
						<ListItemText className="whitespace-nowrap" primary={t('services_settings')}/>
					</ListItemButton>
				</ListItem>
				{/*<Divider/>*/}
				{/*<ListItem disablePadding>*/}
				{/*	<ListItemButton component={Link} to="/radio">*/}
				{/*		<ListItemIcon>*/}
				{/*			<RadioIcon/>*/}
				{/*		</ListItemIcon>*/}
				{/*		<ListItemText className="whitespace-nowrap" primary={t('radio_settings')}/>*/}
				{/*	</ListItemButton>*/}
				{/*</ListItem>*/}
				<Divider/>
			</List>
		</Drawer>
	);
}
